const prefix = 'DimCommodityGroup';

export enum DimCommodityGroupField {
  ID = `${prefix}.id`,
  NAME = `${prefix}.name`,
  DESCRIPTION = `${prefix}.description`,
}
